/**
 * Display labels for IoT connection enums. '50 Hz'/'60 Hz' are locale-invariant;
 * 'Variable' and the contract tier names are translation keys — wrap the result
 * in t() at the call site.
 */

export const operatingFrequencyLabel = (value?: string | null): string | undefined => {
    switch (value) {
        case 'HZ_50':
            return '50 Hz';
        case 'HZ_60':
            return '60 Hz';
        case 'VARIABLE':
            return 'Variable';
        default:
            return value ?? undefined;
    }
};

export const contractTypeLabel = (value?: string | null): string | undefined => {
    switch (value) {
        case 'STARTER':
            return 'Starter';
        case 'STANDARD':
            return 'Standard';
        // schema value is ADVANCE, the product tier name is "Advanced"
        case 'ADVANCE':
            return 'Advanced';
        case 'TESTER':
            return 'Tester';
        default:
            return value ?? undefined;
    }
};

// TYR WT pumps only; null for every other product and for connections created
// before the field existed.
export const acousticEnclosureLabel = (value?: string | null): string | undefined => {
    switch (value) {
        case 'WITH_ACOUSTIC':
            return 'With acoustic enclosure';
        case 'WITHOUT_ACOUSTIC':
            return 'Without acoustic enclosure';
        default:
            return value ?? undefined;
    }
};
